<template>
  <div class="devis-page">
    <navbar
      is-blur="blur blur-rounded my-3 py-2 start-0 end-0 mx-4 shadow"
      btn-background="bg-gradient-success"
      :dark-mode="true"
    />
    <div class="min-vh-100 d-flex align-items-center">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8 text-center">
            <h1 class="display-4 fw-bold mb-4">Demander un Devis</h1>
            <p class="lead mb-4">
              Obtenez une estimation personnalisée pour digitaliser votre établissement scolaire
              avec NetNote.
            </p>
            <router-link to="/" class="btn btn-dark btn-lg rounded-pill">
              <i class="fas fa-arrow-left me-2"></i>Retour à l'accueil
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <app-footer />
  </div>
</template>

<script>
import Navbar from "@/examples/PageLayout/Navbar.vue";
import AppFooter from "@/examples/PageLayout/Footer.vue";

export default {
  name: "DevisPage",
  components: {
    Navbar,
    AppFooter
  }
}
</script>

<style scoped>
.devis-page {
  background: #CBDCEB;
  min-height: 100vh;
}
</style>
